import useLocationWingyou from './useLocationWingyou'

export type IAiSummaryType = 'wingitnorthLocationWingyou'

export const hooks = [
  ['wingitnorthLocationWingyou', useLocationWingyou],
] as const
